/** 变化率（%）；基期为 0 时返回 null */
export const computePeriodChangeRate = (current, previous) => {
	const cur = Number(current) || 0;
	const prev = Number(previous) || 0;
	if (prev === 0) return null;
	return ((cur - prev) / prev) * 100;
};

export const formatPeriodChangeRate = (rate) => {
	if (rate == null || Number.isNaN(rate)) return null;
	const rounded = Math.round(rate * 10) / 10;
	const sign = rounded > 0 ? '+' : '';
	return `${sign}${rounded}%`;
};

export const formatPeriodBaselineValue = (value, mode = 'number') => {
	const num = Number(value) || 0;
	if (mode === 'currency') {
		if (num >= 10000) return `¥${(num / 10000).toFixed(2)}万`;
		return `¥${num.toLocaleString('zh-CN', { maximumFractionDigits: 0 })}`;
	}
	if (mode === 'percent') {
		return `${(Math.round(num * 10) / 10).toFixed(1)}%`;
	}
	return `${num}单`;
};

/**
 * @returns {{ label: string, tone: 'up'|'down'|'flat'|'new', title: string, deltaPrefix: string } | null}
 */
export const resolvePeriodDeltaDisplay = (
	current,
	previous,
	{ mode = 'number', periodLabel = '', baselineLabel = '基期', deltaPrefix = '同比' } = {},
) => {
	const cur = Number(current) || 0;
	const prev = Number(previous) || 0;
	const baselineText = formatPeriodBaselineValue(prev, mode);
	const periodPrefix = periodLabel ? `${baselineLabel}（${periodLabel}）` : baselineLabel;

	if (prev === 0) {
		return {
			label: `基期 ${baselineText}`,
			tone: 'flat',
			title: `${periodPrefix} ${baselineText}`,
			deltaPrefix,
		};
	}

	const rate = computePeriodChangeRate(cur, prev);
	const formatted = formatPeriodChangeRate(rate);
	if (!formatted) return null;

	return {
		label: formatted,
		tone: rate > 0 ? 'up' : rate < 0 ? 'down' : 'flat',
		title: `${periodPrefix} ${baselineText}`,
		deltaPrefix,
	};
};

export const resolveYoyDeltaDisplay = (current, previous, options = {}) =>
	resolvePeriodDeltaDisplay(current, previous, {
		...options,
		baselineLabel: options.baselineLabel ?? '去年同期',
		deltaPrefix: options.deltaPrefix ?? '同比',
	});

export const resolveMomDeltaDisplay = (current, previous, options = {}) =>
	resolvePeriodDeltaDisplay(current, previous, {
		...options,
		baselineLabel: options.baselineLabel ?? '上期',
		deltaPrefix: options.deltaPrefix ?? '环比',
	});

export const resolveBasetrendRow = (baselineLensData, selectedPhase) => {
	if (!baselineLensData) return null;
	if (!selectedPhase) return baselineLensData.overview ?? null;
	return baselineLensData.phases?.find((row) => row.phase === selectedPhase) ?? null;
};

export const buildBaselinePhaseMap = (lensData) => Object.fromEntries((lensData?.phases ?? []).map((row) => [row.phase, row]));
